/** Covenant MOB from deal/installment (1-based) → cohort grid period (0-based). */
export function roasTargetToCohortPeriod(covenantPeriod) {
  const periodNumber = Number(covenantPeriod);
  if (!Number.isFinite(periodNumber)) {
    return null;
  }
  return periodNumber - 1;
}

export function buildRoasTargetValueByCohortPeriod(roasTargets) {
  const targetByCohortPeriod = new Map();
  for (const target of roasTargets ?? []) {
    const cohortPeriod = roasTargetToCohortPeriod(target.period);
    if (cohortPeriod == null) {
      continue;
    }
    targetByCohortPeriod.set(cohortPeriod, Number(target.value));
  }
  return targetByCohortPeriod;
}
